import { render } from "./sobreNosotros.vue?vue&type=template&id=0c1beab7"
import script from "./sobreNosotros.vue?vue&type=script&lang=js"
export * from "./sobreNosotros.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__